import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import LightBoxImage from '~/app/common/LightBoxImage';
import { TrainingDetail } from '~/training/types';
import EmptyMessage from '../EmptyMessage';
import ResourceLink from '../ResourceLink';

export interface TrainingAttachmentsProps {
  images: TrainingDetail['images'];
  pdfs: TrainingDetail['pdfs'];
}

export type TrainingAttachmentsComponent = React.FC<TrainingAttachmentsProps>;

const TrainingAttachments: TrainingAttachmentsComponent = ({ images, pdfs }) => {
  const { t } = useTranslation('training');

  const hasImages = (images?.length ?? 0) > 0;
  const hasPdfs = (pdfs?.length ?? 0) > 0;

  if (!hasImages && !hasPdfs) {
    return <EmptyMessage message={t('attachments.noAttachmentAdded')} />;
  }

  return (
    <div className={classes['attachments']}>
      {hasImages && (
        <div>
          <p className={classes['attachment-label']}>{t('attachments.images')}</p>
          <div className={classes['attachment-images']}>
            {images.map((image, index) => (
              <div key={image.url || image.name || index} className={classes['training-image']}>
                <LightBoxImage image={image.url} />
              </div>
            ))}
          </div>
        </div>
      )}
      {hasPdfs && (
        <div>
          <p className={classes['attachment-label']}>{t('attachments.pdfs')}</p>
          <div className={classes['resources']}>
            {pdfs.map((pdf, index) => (
              <ResourceLink
                key={pdf.url || pdf.name || index}
                href={pdf.url}
                icon={<Icon name="picture_as_pdf" />}
                title={pdf.name}
                wrapTitleInSpan={false}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingAttachments;
